import { useAuthStore } from "../../store/useAuthStore";
import { userIdFromToken } from "../lib/jwt";

/** Signed-in user's id: the loaded profile, or the token's `sub` before it arrives. */
export function useMyUserId(): number | null {
  const id = useAuthStore((s) => s.id);
  const token = useAuthStore((s) => s.accessToken);
  return id ?? userIdFromToken(token);
}

export function getMyUserId(): number | null {
  const { id, accessToken } = useAuthStore.getState();
  return id ?? userIdFromToken(accessToken);
}
